export default "__VITE_ASSET__D25_AJEG__"